import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DragDropDocumentService {
  private pendingFiles: File[] = [];

  // Supported file extensions by Box
  private readonly SUPPORTED_EXTENSIONS = [
    '.pdf', '.csv', '.xlsx', '.xls', '.docx', '.doc', '.rtf', '.txt',
    '.pptx', '.ppt', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg',
    '.mp4', '.avi', '.mov', '.wmv', '.flv', '.mkv', '.webm',
    '.mp3', '.wav', '.flac', '.aac', '.ogg',
    '.zip', '.rar', '.7z', '.tar', '.gz', '.epub', '.webp',
  ];

  setPendingFiles(files: File[]): void {
    this.pendingFiles = files;
  }

  getPendingFiles(): File[] {
    return [...this.pendingFiles];
  }

  clearPendingFiles(): void {
    this.pendingFiles = [];
  }

  hasPendingFiles(): boolean {
    return this.pendingFiles.length > 0;
  }

  hasUnsupportedFiles(): boolean {
    return this.pendingFiles.some((file) => !this.isSupportedFormat(file));
  }

  private isSupportedFormat(file: File): boolean {
    const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    return this.SUPPORTED_EXTENSIONS.includes(extension);
  }
}
